// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"a610ef02","270":"73b27fb7","580":"47a5bc47","675":"a169abeb","704":"cd122927","712":"140f738c"}[chunkId] + ".chunk.js";
};